import { useMutation } from "@apollo/client/react";
import ModalProvider from "@repo/components/src/globalProviders/modal";
import LoadingButton from "@repo/components/src/shared/loadingButton";
import { BasicModal } from "@repo/components/src/shared/modal";
import { ButtonText } from "@repo/components/src/ui/button";
import { Text } from "@repo/components/src/ui/text";
import { ChangePlanDocument } from "@repo/graphql/documents/subscription/mutation.generated";
import {
  WorkspaceBillingSettingsDocument,
  WorkspaceFreeTrialDocument,
  WorkspacePlanSettingsDocument,
  WorkspacePlanSettingsQuery,
} from "@repo/graphql/documents/workspace/query.generated";
import React from "react";
import {
  PaymentRecurringFragmentFragment,
  PlanPricingFragmentFragment,
} from "@repo/graphql/documents/workspace/fragment.generated";

type Props = {
  price: PlanPricingFragmentFragment["priceSet"][number];
  plan: NonNullable<
    WorkspacePlanSettingsQuery["subscription"]["listPlans"]
  >[number];
  onSuccess?: () => void;
  paymentRecurring: PaymentRecurringFragmentFragment;
};

const ChangePlan = React.memo((props: Props) => {
  const { plan: planFragment, paymentRecurring, price, onSuccess } = props;
  const plan = planFragment;
  const [changePlan, { loading: loadingChangePlan }] = useMutation(
    ChangePlanDocument,
    {
      onCompleted: () => {
        ModalProvider.hide();
        onSuccess?.();
      },
      refetchQueries: [
        WorkspacePlanSettingsDocument,
        WorkspaceBillingSettingsDocument,
        WorkspaceFreeTrialDocument,
      ],
      awaitRefetchQueries: true,
    },
  );
  return (
    <BasicModal>
      <Text size="2xl">Cambiarás al plan {plan.name}</Text>
      <Text className="mt-6">
        El nuevo plan se activará en tu próximo cobro mensual, que se realizará
        con tu tarjeta terminada en ****{paymentRecurring.lastFourDigits}.
      </Text>
      <LoadingButton
        className="mt-6"
        action="brand"
        rounded="lg"
        variant="solid"
        loading={loadingChangePlan}
        onPress={() => changePlan({ variables: { priceId: price.id } })}
      >
        <ButtonText>Comprar plan {plan.name}</ButtonText>
      </LoadingButton>
    </BasicModal>
  );
});

ChangePlan.displayName = "ChangePlan";

export default ChangePlan;
